import React from 'react';

import RichTextElement from '../../Elements/RichText';

import {
  SectionPromotionBannerProps,
  ImageKeys,
} from './types/SectionPromotionBanner.types';
import CtaButtonRow from '../../Elements/CtaButtons/CtaButtonRow';
import {
  PromotionButtonContainer,
  PromotionDesktopImageContainer,
  PromotionInnerContainer,
  PromotionMobileImageContainer,
  PromotionOuterContainer,
  PromotionTextContainer,
} from './styles/SectionPromotionBanner.styles';

const SectionPromotionBanner: React.FC<SectionPromotionBannerProps> = ({
  content,
  responsiveImageCollection,
}) => {
  const CONTENTFUL_SECTION_ELEMENT_RICH_TEXT =
    'ContentfulSectionElementRichText';
  const CONTENTFUL_SECTION_ELEMENT_BUTTON_ROW =
    'ContentfulSectionElementCtaButtonRow';
  const images = responsiveImageCollection
    ? responsiveImageCollection.map(respImage => {
        const container: Record<ImageKeys, any> = {};

        container['source'] = respImage.imageTitle.file.url;
        container['maxWidth'] = respImage.maxWidth;
        container['mobileImageSource'] =
          respImage.mobileBackgroundImage?.file?.url ?? null;
        container['imageName'] = respImage.imageName ?? 'banner_image';

        return container;
      })
    : [];

  const desktopImageSrc = images.reduce((acc, css, idx) => {
    return css.source;
  }, '');

  const mobileImageSrc = images.reduce((acc, css, idx) => {
    return css.mobileImageSource;
  }, '');

  const imageAlt = images.reduce((acc, css, idx) => {
    return css.imageName;
  }, '');

  const ctaButtonRow = content.map(content => {
    if (content.__typename === CONTENTFUL_SECTION_ELEMENT_BUTTON_ROW) {
      return (
        <PromotionButtonContainer>
        <CtaButtonRow
          key={content.id}
          buttonRowAlignment={content.buttonRowAlignment}
          isMobileViewButtonOrderReversed={
            content.isMobileViewButtonOrderReversed
          }
          buttons={content.buttons}
        />
        </PromotionButtonContainer>
      );
    }
  });

  const textContent = content.map(content => {
    if (content.__typename === CONTENTFUL_SECTION_ELEMENT_RICH_TEXT) {
      return (
        <PromotionTextContainer>
                  <RichTextElement
          key={content.id}
          className="richText"
          rawRichText={content.text?.raw}
          text={content.text}
          color={content.color}
          textAlign={content.textAlign}
        />
        </PromotionTextContainer>
      );
    }
  });

  return (
    <PromotionOuterContainer>
      <PromotionInnerContainer>
        {textContent && <div>{textContent}</div>}
        <PromotionDesktopImageContainer>
          <img src={desktopImageSrc} alt={imageAlt} />
        </PromotionDesktopImageContainer>
        <PromotionMobileImageContainer>
          <img src={mobileImageSrc} alt={imageAlt} />
        </PromotionMobileImageContainer>
        {ctaButtonRow && <div>{ctaButtonRow}</div>}
      </PromotionInnerContainer>
    </PromotionOuterContainer>
  );
};

export default SectionPromotionBanner;
